export function isImmersiveRoute(pathname: string): boolean {
  if (pathname === '/intro') return true;
  if (pathname === '/get-started') return true;
  if (pathname.startsWith('/strategy-studio/neuro-truth')) return true;
  if (pathname.startsWith('/strategy-studio/compiler')) return true;
  if (pathname.startsWith('/scenarios')) return true;
  if (pathname.startsWith('/blueprint/fusion-v2')) return true;
  return false;
}

export function isOperatingContextHiddenRoute(pathname: string): boolean {
  if (pathname.match(/^\/strategy-studio\/strategies\/[^/]+\/blueprint-runs(\/|$)/)) return true;
  return false;
}

/**
 * Routes where the main app sidebar should be completely hidden
 * (the page provides its own navigation and should be full-bleed)
 */
export function isHiddenSidebarRoute(pathname: string): boolean {
  return pathname === '/ask' || pathname.startsWith('/ask/');
}

